<template>
  <div class="community" v-title data-title="广东多对多物联集团股份有限公司">
    <div class="part1 container">
      <div class="title">
        实现社区人、车有序，智能化三防治理，流动人车的数据化管理；<br />实现社区服务与家庭以全天候零距离交互，社区管理降本增效。
      </div>
      <div class="line"></div>
      <div class="zhsq">
        <div class="left">
          <ul>
            <li>
              <div class="title_1">智慧小区管理</div>
              <p>
                公告、通知发布<br />
                报修和报事<br />
                工单管理、车位管理、业主管理<br />
                房产管理、出入管理、活动组织<br />
                居民的在线投票及统计
              </p>
            </li>
            <li>
              <div class="title_1">智能控制系统</div>
              <p>
                智能控制社区大门<br />
                智能控制社区公共监控摄像头<br />
                智能控制停车道闸<br />
                智能控制社区安全警报系统<br />
                智能控制社区广告设备
              </p>
            </li>
            <li>
              <div class="title_1">健康与养老</div>
              <p>
                移动的图书馆<br />
                家庭健康档案管理服务<br />
                家庭健康顾问对接服务<br />
                健康专家预约服务<br />
                老年互动管理服务<br />
                同步应急救援
              </p>
            </li>
          </ul>
        </div>
        <div class="right">
          <ul>
            <li>
              <div class="title_1">智慧社区党建系统</div>
              <p>
                资讯门户：党情“速递”<br />
                组织生活：无处不在<br />
                交流互动：以党带群，党群互动<br />
                积分激励：促进创先争优，与时俱进<br />
                屏上党建：随时随地，多屏互动
              </p>
            </li>
            <li>
              <div class="title_1">社区网格化管理</div>
              <p>
                基础数据平台<br />
                统计分析平台<br />
                社情民意平台<br />
                督办督查平台<br />
                考核评比平台<br />
                指挥中心平台<br />
                系统管理平台<br />
                百姓互动平台
              </p>
            </li>
            <li>
              <div class="title_1">联接智慧家庭</div>
              <p>
                多对多共享平台通过多屏互动，多网互通，多品互联，提供全场景、一体化家庭智慧生活解决方案，为智慧社区管理联接到智慧家庭打好基础，为安全、有趣的社区生活保驾护航。
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="part2 container-fluid">
      <h3 class="title">多对多智能控制系统</h3>
      <div class="line"></div>
      <p class="titBt">
        智慧社区解决方案，以人们生活质量为先，围绕住户个性化需求，充分利用物联网、云计算、移动互联网、<br />人工智能等新一代信息技术和优质产品为人们提供一个安全、舒适、便利的生活环境和高端生活体验。
      </p>
      <div class="img_box">
        <img src="~img/community/part2img.png" alt="" />
      </div>
      <div class="znkz">
        <div class="grayLine"></div>
        <div class="grayLine"></div>
        <div class="znkzCont">
          <h3 class="name b"><span>智能</span><span>控制系统</span></h3>
          <div class="znkzList">
            <ul class="item">
              <li>
                <div class="tit">人<br />脸<br />识<br />别</div>
                <div class="imgBox">
                  <img src="~img/neighbourhood/rlsb.png" alt="" />
                </div>
                <div class="text">
                  <div class="tit">门禁系统</div>
                  <ul>
                    <li>多种解锁方式</li>
                    <li>可视对讲</li>
                    <li>人脸识别</li>
                    <li>远程开锁</li>
                  </ul>
                  <p></p>
                </div>
              </li>
              <li>
                <div class="tit">二<br />维<br />码<br />识<br />别</div>
                <div class="imgBox">
                  <img src="~img/neighbourhood/ewmsb.png" alt="" />
                </div>
                <div class="text">
                  <div class="tit">巡更管理</div>
                  <ul>
                    <li>RFID应用</li>
                    <li>GPS精准定位</li>
                    <li style="width: 200px">云端巡更管理系统</li>
                  </ul>
                  <p></p>
                </div>
              </li>
              <li>
                <div class="tit g">刷<br />卡<br />识<br />别</div>
                <div class="imgBox">
                  <img src="~img/neighbourhood/sksb.png" alt="" />
                </div>
                <div class="text">
                  <div class="tit">消费管理</div>
                  <ul>
                    <li>人脸识别</li>
                    <li>智能缴费</li>
                  </ul>
                  <p></p>
                </div>
              </li>
              <li>
                <div class="tit g">
                  智<br />能<br />手<br />环<br />识<br />别
                </div>
                <div class="imgBox">
                  <img src="~img/neighbourhood/znshsb.png" alt="" />
                </div>
                <div class="text">
                  <div class="tit">电梯管理</div>
                  <ul>
                    <li>楼层权限管理</li>
                    <li>人脸识别</li>
                    <li>楼宇对讲</li>
                    <li>定时预约</li>
                  </ul>
                  <p></p>
                </div>
              </li>
              <li>
                <div class="tit">车<br />牌<br />识<br />别</div>
                <div class="imgBox">
                  <img src="~img/neighbourhood/cpsb.png" alt="" />
                </div>
                <div class="text">
                  <div class="tit">车辆管理</div>
                  <ul>
                    <li>车牌识别</li>
                    <li>空车位指示</li>
                    <li>智能缴费</li>
                    <li>停车导航</li>
                  </ul>
                  <p></p>
                </div>
              </li>
              <li>
                <div class="tit">射<br />频<br />识<br />别</div>
                <div class="imgBox">
                  <img src="~img/neighbourhood/spsb.png" alt="" />
                </div>
                <div class="text">
                  <div class="tit">考勤管理</div>
                  <ul>
                    <li>人脸识别</li>
                    <li>智能提醒</li>
                    <li>定位考勤</li>
                    <li>报表导出</li>
                  </ul>
                  <p></p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="part3">
      <h3 class="title">多对多视频监控</h3>
      <div class="line"></div>
      <div class="moive_flex_box">
        <div class="moive_box">
          <h6>出入口（社区出入口，住宅出入口）</h6>
          <ul>
            <li>·社区出入口设置筒型摄像机+人脸识别摄像头；</li>
            <li>·住宅出入口设置筒型摄像机</li>
          </ul>
        </div>
        <div class="moive_box">
          <h6>周界（社区周界，住宅楼周界）</h6>
          <ul>
            <li>·设置筒型摄像机进行监控的同时，可以与周界探测设备联合防范</li>
          </ul>
        </div>
        <div class="moive_box">
          <h6>车道和人行道</h6>
          <ul>
            <li>
              ·主干道设置筒型摄像机，具备变焦，白光补偿，透雾，防抖动等特性；
            </li>
            <li>·人行道设置设置筒型摄像机具备红外补偿透雾防抖动等特性；</li>
          </ul>
        </div>
      </div>
      <div class="moive_img">
        <img src="~img/community/part3-line.png" alt="" />
      </div>
      <div class="moive_flex_box_two">
        <div class="moive_box">
          <h6>安保部门：门卫室（传达室）</h6>
          <ul>
            <li>·监控中心（监控室），住宅值班室</li>
            <li>·设置半球摄像机</li>
          </ul>
        </div>
        <div class="moive_box">
          <h6>室内部位：（走廊，大厅，重点区域，电梯）</h6>
          <ul>
            <li>·设置半球摄像机，定点监控</li>
          </ul>
        </div>
        <div class="moive_box">
          <h6>社区制高点：楼顶，天台</h6>
          <ul>
            <li>·设置热成像摄像机</li>
          </ul>
        </div>
        <div class="moive_box">
          <h6>大型活动区域：室外活动区（花园等）</h6>
          <ul>
            <li>·设置球型摄像机，对区域轮巡</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="Intelligent_garage top_shadow">
      <div class="head_title_img">
        <div class="div_1">
          <img src="~img/community/img2.png" alt="" />
          <p>视频监控大屏</p>
        </div>
        <div class="div_2">
          <img src="~img/community/img3.png" alt="" />
          <p>移动观看</p>
        </div>
        <div class="div_3">
          <img src="~img/community/img4.png" alt="" />
          <p>云存储</p>
        </div>
        <div class="div_4">
          <img src="~img/community/img5.png" alt="" />
          <p>火灾预防</p>
        </div>
        <div class="div_5">
          <img src="~img/community/img6.png" alt="" />
          <p>行为分析</p>
        </div>
        <div class="div_6">
          <img src="~img/community/img7.png" alt="" />
          <p>高效管理</p>
        </div>
        <h3 class="word">
          实现社区物业集中远程视频控制，电视，电脑，手机随时随地可查看所有公共区域的监控，智能
          监控公共区域安全情况。居民在家中也能通过各种安全防护设备对家中情况进行监控，异动及时提醒，安全放心。
        </h3>
      </div>
    </div>

    <div class="barn">
      <div class="head_title">
        <p class="p1">多对多数字停车</p>
        <p class="line"></p>
        <p class="p3">
          量身定制车库智能屏，车牌识别，车库信息一目了然，轻松便捷
        </p>
      </div>

      <div class="barn_tab_img">
        <div class="top">
          <div class="top_div1 top_div">
            <div class="top_div_left">
              <img src="~img/community/img9.png" alt="" />
              <p></p>
            </div>
            <div class="top_div_right">
              <p class="p1"></p>
              <p class="p2"></p>
              <p class="p3">无需排队<br />快速通行</p>
            </div>
          </div>
          <div class="top_div2 top_div">
            <div class="top_div_left">
              <img src="~img/community/img10.png" alt="" />
              <p></p>
            </div>
            <div class="top_div_right">
              <p class="p1"></p>
              <p class="p2"></p>
              <p class="p3">轻松停车<br />无需寻位</p>
            </div>
          </div>
        </div>
        <div class="centre">
          <img src="~img/community/img8.png" alt="" />
        </div>
        <div class="bottom">
          <div class="bottom_div bottom_div_1">
            <div class="bottom_div_1_left">
              <p></p>
              <img src="~img/community/img11.png" alt="" />
            </div>
            <div class="bottom_div_1_right">
              <p class="p1 p4"></p>
              <p class="p2 p4"></p>
              <p class="p3">车牌识别</p>
            </div>
          </div>
          <div class="bottom_div bottom_div_2 bottom_div_3">
            <div class="bottom_div_1_left">
              <p class="p1 p4"></p>
              <p class="p2 p4"></p>
              <p class="p3">访客车辆预约<br />代缴费等温馨服务</p>
            </div>
            <div class="bottom_div_1_right">
              <p></p>
              <img src="~img/community/img12.png" alt="" />
            </div>
          </div>
          <div class="bottom_div bottom_div_2 bottom_div_4">
            <div class="bottom_div_1_left">
              <p class="p1 p4"></p>
              <p class="p2 p4"></p>
              <p class="p3">错时共享停车<br />物业空间增值</p>
            </div>
            <div class="bottom_div_1_right">
              <p></p>
              <img class="img_5" src="~img/community/img13.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gating">
      <div class="head_title">
        <p class="p1">多对多数字门控</p>
        <p class="line"></p>
        <p class="p3">无卡门禁，加强管理，更便捷</p>
      </div>

      <div class="gating_content">
        <div class="gating_content_left">
          <div class="gating_content_div1">
            <p>业主回家</p>
          </div>
          <div class="gating_content_div2">
            <img src="~img/community/img14.png" alt="" />
          </div>
          <div class="gating_content_div3">
            <div class="div_1">
              <img src="~img/community/img16.png" alt="" />
              <p>单元门口机人脸识别</p>
            </div>
            <div>
              <img src="~img/community/img17.png" alt="" />
              <p>人脸识别到达指定楼层</p>
            </div>
            <div>
              <img src="~img/community/img18.png" alt="" />
              <p>指纹开启门锁</p>
            </div>
          </div>
        </div>
        <div class="gating_content_right">
          <div class="gating_content_div4">
            <p>客人来访</p>
          </div>
          <div class="gating_content_div5">
            <img src="~img/community/img15.png" alt="" />
          </div>
          <div class="gating_content_div6">
            <div class="div_2">
              <img src="~img/community/img19.png" alt="" />
              <p>小区可视对讲</p>
            </div>
            <div>
              <img src="~img/community/img20.png" alt="" />
              <p>授权二维码</p>
            </div>
            <div>
              <img src="~img/community/img21.png" alt="" />
              <p>二维码解锁门禁</p>
            </div>
            <div>
              <img src="~img/community/img22.png" alt="" />
              <p>刷二维码到达指定楼层</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ladder">
      <div class="head_title">
        <p class="p1">多对多数字梯控</p>
        <p class="line"></p>
        <p class="p3">
          内置智能屏，刷脸或指纹锁定楼层，免按直达，智能管理，更安全便捷，避免各业主，住户受到不必要的骚扰，加强楼宇的保安,<br />
          提高物业的智能化管理，支持环保倡议（省电），为业主提供人性化服务。
        </p>
      </div>

      <div class="ladder_img">
        <img src="~img/community/img23.png" alt="" />
      </div>

      <div class="ladder_content">
        <div class="ladder_content_div">
          <div class="ladder_content_div_content">
            <div class="left">
              <img class="img_1" src="~img/community/img24.png" alt="" />
              <p>人脸识别</p>
            </div>
            <div class="right">
              <p><span></span>支持IC刷卡，人脸识别；</p>
              <p>
                <span></span
                >住户可根据出门时间，使用直达锁住楼层，无权限人员未经允许无法正常使用电梯
              </p>
            </div>
          </div>
          <div class="ladder_content_div_content">
            <div class="left">
              <img class="img_2" src="~img/community/img25.png" alt="" />
              <p>定时预约</p>
            </div>
            <div class="right">
              <p><span></span>住户可根据出门时间，使用预约电梯功能；</p>
              <p>
                <span></span
                >通过APP住户可以知道预约电梯的所在楼层，而节省出行时间(使用于早
                晚高峰时段)
              </p>
            </div>
          </div>
        </div>
        <div class="ladder_content_div right_div">
          <div class="ladder_content_div_content">
            <div class="left">
              <img class="img_4" src="~img/community/img27.png" alt="" />
              <p>定时预约</p>
            </div>
            <div class="right">
              <p><span></span>装修，家居搬运时候，电梯限时预约；</p>
              <p><span></span>消防等特殊情况下，临时限制用户权限；</p>
              <p>
                <span></span>应急情况(孕产， 心脏病等)，临时提高用户电梯使用权限
              </p>
            </div>
          </div>
          <div class="ladder_content_div_content ladder_content_div_content_4">
            <div class="left">
              <img class="img_3" src="~img/community/img26.png" alt="" />
              <p>人脸识别</p>
            </div>
            <div class="right">
              <p>
                <span></span
                >住户可通过可视对讲系统，呼叫相应楼层的邻居，获得临时出入密码
              </p>
              <p><span></span>并预约电梯输入密码获得出入楼层的权限</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "community",
  metaInfo: {
    meta: [
      {
        name: "keywords",
        content:
          "多对多物联集团、银发经济、人口老龄化、心脑血管、慢性疾病、血压高、血糖、体脂管理、中医馆、养生馆、健康管理师、科学工作站、公益行动、老年产品目录、健康机构、客户管理、拓客、医保社保、养生保健、远程管理",
      },
      {
        name: "discription",
        content:
          "多对多物联集团是一家深耕于大健康领域多年的健康管理数智服务商，是华为战略合作伙伴，华为健康数据与多对多实现互联互通。多对多健康管理 SaaS 系统和健康管理拓客赢利AI解决方案，为用户建立健康档案，提供健康 AI 管理。业务涵盖医院、养老机构、社区中心、康养中心、养老院、中医馆、养生馆等。针对人口老龄化现状和银发经济趋势，多对多加入了科学健康指导工作站，百城千镇家庭防大病数智服务健康公益行动办公室。开放专业健康管理师进驻，实现合作加盟共赢。",
      },
    ],
  },
};
</script>

<style scoped lang="less">
.community .title {
  text-align: center;
}

// css start
.top_shadow {
  box-shadow: 0 -10px 10px -3px #ffeeee;
}

// 公共css --- start
.head_title {
  text-align: center;
  .p1 {
    font-size: 28px;
    color: #000;
    font-weight: bold;
    .vertical {
      background-color: #000;
      width: 2px;
      height: 18px;
      display: inline-block;
      position: relative;
      top: 3px;
    }
    .spot_1 {
      position: relative;
      top: -5px;
    }
  }
  .line {
    width: 40px;
    height: 2px;
    margin: 20px auto 0;
    background: #ee7b1d;
  }
  .p3 {
    margin-top: 16px;
    font-size: 18px;
    color: #7c7a7a;

    .min_spot {
      font-size: 12px;
      margin: 0 2px;
      position: relative;
      top: -3px;
      color: #7c7a7a;
    }
    .span_color {
      color: #ee7b1d;
    }
  }
}

.support_1 {
  height: 50px;
}

// css end

.community {
  box-shadow: 0 10px 10px -3px #efefef;

  .part3 {
    width: 1244px !important;
    margin: 0 auto;
    .title {
      font-size: 28px;
      color: #000;
      font-weight: bold;
    }
    .line {
      height: 2px;
      width: 50px;
      background: #f1954a;
      margin: 20px auto;
    }

    padding: 50px 0;

    @media (max-width: 992px) {
      width: 100% !important;
    }

    @media (max-width: 576px) {
      padding: 40px 0;
    }

    .imgBox {
      position: relative;

      img {
        width: 100%;
      }

      .text {
        width: 62%;
        position: absolute;
        bottom: 5%;
        right: 0;
        font-size: 18px;
        line-height: 30px;
      }

      @media (max-width: 992px) {
        .text {
          font-size: 1rem;
          line-height: 1.4rem;
          bottom: 0;
        }
      }

      @media (max-width: 768px) {
        .text {
          width: 100%;
          position: static;
          font-size: 1rem;
          padding: 20px 0;
        }
      }

      @media (max-width: 576px) {
        padding: 20px;

        .text {
          width: 100%;
          position: static;
          font-size: 1rem;
        }
      }
    }
  }

  .part2 {
    .title {
      font-size: 28px;
      color: #000;
      font-weight: bold;
    }
    .img_box {
      width: 1224px;
      margin: 0 auto;

      @media (max-width: 992px) {
        display: none;
      }
    }

    .line {
      height: 2px;
      width: 50px;
      background: #f1954a;
      margin: 20px auto;
    }

    .titBt {
      text-align: center;
      font-size: 14px;
      color: #8d8e90;
      margin: 0 auto;
      padding: 0 4% 5% 4%;
      line-height: 24px;
    }
  }

  .line-box {
    padding: 80px 0 40px 0;
    width: 1244px;
    margin: 0 auto;
    height: 523px;
    display: none;
    background: url("~img/community/part2-line.png") no-repeat center;
    background-size: 100%;

    @media (max-width: 992px) {
      display: none;
    }
  }

  .part1 {
    padding: 80px 0 40px 0;
    // background: url("~img/community/part1Bg.png") no-repeat center;
    // background-size: 100% 100%;
    // width: 1920px;
    // height: 762px;
    position: relative;
    margin: 0 auto;

    @media (max-width: 992px) {
      background: none;
      padding: 70px 0 30px 0;
    }

    .title {
      font-size: 22px;
      text-align: center;
      line-height: 42px;
      padding: 0 20px;

      @media (max-width: 576px) {
        font-size: 1rem;
      }
    }

    .line {
      height: 2px;
      width: 50px;
      background: #f1954a;
      margin: 20px auto;
    }

    .zhsq {
      display: flex;
      justify-content: space-between;
      padding-top: 30px;
      background: url("~img/community/part1Bg.png") no-repeat center;
      // background-size: 100% 100%;
      @media (max-width: 992px) {
        background: none;
      }
      .left,
      .right {
        .title_1 {
          font-size: 18px;
          color: #f1954a;
          line-height: 42px;
        }

        ul {
          width: 320px;

          li {
            p {
              font-size: 12px;
              line-height: 20px;
            }
          }
        }

        &.left {
          li {
            height: 200px;
            padding: 0 0 0 30px;

            &:nth-child(2) {
              height: 175px;
            }
          }
        }

        &.right {
          ul {
            li {
              height: 160px;
              padding: 0 0 0 113px;
              &:nth-child(2) {
                height: 215px;
              }
            }
          }
        }
      }
    }

    @media (max-width: 768px) {
      text-align: center;

      .title {
        text-align: center !important;
        padding: 10px 20px;
      }

      padding: 60px 0 20px 0;

      .zhsq {
        flex-wrap: wrap;
        justify-content: center;

        ul li {
          padding: 10px !important;
          height: auto !important;

          p {
            font-size: 1rem !important;
            line-height: 1.5rem !important;
          }
        }
      }
    }

    @media (max-width: 576px) {
      padding: 40px 0 20px 0;
    }
  }
}

.moive_flex_box {
  width: 1244px;
  display: flex;
  justify-content: space-evenly;

  @media (max-width: 992px) {
    width: 100%;
    flex-wrap: wrap;
  }
}

.moive_img {
  text-align: center;
  margin: 4px 0;

  @media (max-width: 992px) {
    display: none;
  }
}

.moive_flex_box_two {
  width: 1244px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 992px) {
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
}

.moive_box {
  width: 20%;
  height: 180px;
  box-shadow: 0px 0px 10px #c8c8c8;
  padding: 2%;

  @media (max-width: 992px) {
    width: 46%;
    margin: 10px 0;
  }

  h6 {
    color: #ee7b1d;
    font-size: 18px;
  }

  li {
    color: #7a7a7a;
    font-size: 14px;
    line-height: 22px;
  }
}

.znkz {
  width: 1244px !important;
  margin: 0 auto;
  position: relative;
  height: 500px;
  box-sizing: border-box;
  padding-top: 118px;

  @media (max-width: 992px) {
    height: auto;
    width: 100% !important;
    padding-top: 50px;
  }

  .grayLine {
    margin-left: 90px;
    width: 80%;
    border: 1px solid #bfbfbf;
    border-right: none;
    height: 118px;

    @media (max-width: 992px) {
      display: none;
    }
  }

  .grayLine:nth-child(2) {
    border-top: none;
  }

  .znkzCont {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50px;
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 992px) {
      position: static;
      justify-content: center;
      flex-direction: column;
    }

    .b {
      color: #ee7b1d;
    }

    .name {
      background: url("~img/trade/znkzbg.png") no-repeat;
      background-size: cover;
      width: 180px;
      height: 190px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      letter-spacing: 3px;

      // margin-left: 1.5%;
      span {
        display: block;
      }
    }

    .znkzList {
      width: 74%;

      @media (max-width: 1200px) {
        width: 76%;
      }

      ul.item {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        li {
          width: 47%;
          background: #fff;
          box-shadow: #bfbfbf 0px 0px 5px;
          margin-bottom: 30px;
          display: flex;
          flex-direction: row;
          @media (max-width: 768px) {
            width: 100%;
          }

          .tit {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 10px;
            color: #ee7b1d;
            font-size: 14px;
            line-height: 14px;

            &.g {
              color: #ee7b1d;
            }
          }

          .imgBox {
            width: 26%;
            border: 1px solid #ee7b1d;
            border-image: linear-gradient(#e5a674, #e5a674) 30 30;
            box-shadow: #e5a674 0px 0px 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 10px;
            img {
              width: 70px;
              height: 66px;
              margin: 10px;
            }
          }

          .text {
            width: 70%;
            font-size: 14px;
            line-height: 20px;
            margin-left: 40px;
            @media (max-width: 576px) {
              margin-left: 10px;
            }
            .tit {
              justify-content: left;
              color: #333;
              padding-top: 10px;
            }

            ul {
              width: 95%;
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
              padding: 2px 0;
              padding-left: 8px;

              li {
                box-shadow: none;
                margin: 0;
              }
            }
          }

          &:nth-child(3) {
            .imgBox {
              img {
                width: 58px;
              }
            }
          }

          &:nth-child(4) {
            .imgBox {
              img {
                width: 50px;
              }
            }
          }

          &:nth-child(5) {
            .imgBox {
              img {
                width: 64px;
              }
            }
          }
        }
      }
    }

    @media (max-width: 992px) {
      .name {
        display: none;
      }

      .znkzList {
        width: 100%;

        ul {
          li {
            .imgBox {
              img {
                width: 100%;
              }
            }
          }
        }
      }
    }

    @media (max-width: 768px) {
      .text {
        .tit {
          font-size: 16px !important;
          padding-bottom: 10px;
        }

        ul {
          display: flex;
          justify-content: left;

          li {
            width: 45% !important;
            font-size: 14px !important;
          }
        }
      }
    }

    @media (max-width: 576px) {
      .text {
        .tit {
          font-size: 17px !important;
          padding-bottom: 10px;
        }

        ul {
          display: flex;
          justify-content: left;

          li {
            width: 45% !important;
            font-size: 15px !important;
          }
        }
      }
    }

    @media (max-width: 508px) {
      .imgBox {
        width: 22% !important;
        text-align: center;

        img {
          width: 90% !important;
          height: auto !important;
        }
      }

      .text {
        .tit {
          font-size: 16px !important;
          padding-bottom: 10px;
        }

        ul {
          display: flex;
          justify-content: left;

          li {
            width: 45% !important;
            font-size: 12px !important;
          }
        }
      }
    }
  }
}

.Intelligent_garage {
  margin-top: 200px;
  @media (max-width: 576px) {
    margin-top: 30px;
  }
  .head_title_img {
    width: 1200px;
    height: 250px;
    margin: 0 auto;
    background-image: url(../../assets/images/community/img1.png);
    background-size: 100% 100%;
    position: relative;
    top: -135px;
    @media (max-width: 576px) {
      width: 100%;
      background-image: none;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      top: 0px;
      height: 650px;
    }
    div {
      width: 143px;
      height: 143px;
      position: absolute;
      top: -60px;
      @media (max-width: 576px) {
        position: static;
        top: 0;
      }
      img {
        width: 143px;
        height: 143px;
        background-size: 100% 100%;
      }
      p {
        text-align: center;
        font-size: 14px;
        color: #ee8835;
        top: -56px;
        position: relative;
      }
    }
    .div_1 {
      left: 64px;
    }
    .div_2 {
      left: 252px;
    }
    .div_3 {
      left: 438px;
    }
    .div_4 {
      left: 622px;
    }
    .div_5 {
      left: 807px;
    }
    .div_6 {
      left: 992px;
    }
    .word {
      padding: 130px 130px 20px;
      font-size: 16px;
      color: #524c4b;
      text-align: center;
      line-height: 22px;
      @media (max-width: 576px) {
        padding: 20px 10px;
        font-size: 16px !important;
        line-height: 17px;
      }
    }
  }
}

.barn {
  .barn_tab_img {
    width: 1200px;
    margin: 30px auto 100px;
    @media (max-width: 576px) {
      width: 98%;
      margin-bottom: 30px;
    }
    .top {
      position: relative;
      height: 118px;
      @media (max-width: 576px) {
        display: flex;
        justify-content: space-between;
      }
      .top_div {
        display: flex;
        justify-content: flex-start;
        width: 180px;
        height: 118px;
        position: absolute;
        @media (max-width: 576px) {
          position: static;
        }
        .top_div_left {
          width: 78px;
          img {
            width: 78px;
            height: 78px;
            background-size: 100% 100%;
          }
          p {
            width: 2px;
            height: 30px;
            margin: 6px auto;
            background-color: #ee8835;
          }
        }
        .top_div_right {
          margin-left: 10px;
          padding: 4px;
          position: relative;
          .p1 {
            position: absolute;
            top: 16px;
            left: 0;
            width: 20px;
            height: 1px;
            background-color: #ee8835;
          }
          .p2 {
            position: absolute;
            top: 16px;
            left: 0;
            width: 1px;
            height: 20px;
            background-color: #ee8835;
          }
          .p3 {
            font-size: 14px;
            color: #524c4b;
            margin: 20px 10px;
          }
        }
      }
      .top_div1 {
        left: 269px;
      }
      .top_div2 {
        left: 856px;
      }
    }
    .centre {
      img {
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
      }
    }
    .bottom {
      height: 118px;
      position: relative;

      @media (max-width: 576px) {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;
        height: 100%;
      }

      .bottom_div {
        position: absolute;
        @media (max-width: 576px) {
          position: static;
          margin: 10px auto;
        }
      }
      .bottom_div_1 {
        display: flex;
        justify-content: flex-start;
        left: -28px;
        .bottom_div_1_left {
          @media (max-width: 576px) {
            width: 100%;
          }
          p {
            width: 2px;
            height: 30px;
            margin: 6px auto;
            background-color: #ee8835;
            @media (max-width: 576px) {
              display: none;
            }
          }
          img {
            width: 78px;
            height: 78px;
            background-size: 100% 100%;
          }
        }
        .bottom_div_1_right {
          margin-left: 10px;
          position: relative;
          .p1 {
            width: 20px;
            height: 1px;
          }
          .p2 {
            height: 20px;
            width: 1px;
          }
          .p4 {
            position: absolute;
            top: 56px;
            left: 0;
            background-color: #ee8835;
            @media (max-width: 576px) {
              top: 15px;
            }
          }
          .p3 {
            font-size: 14px;
            color: #524c4b;
            margin: 60px 10px 0;
            @media (max-width: 576px) {
              margin: 20px 10px 0;
            }
          }
        }
      }

      .bottom_div_2 {
        display: flex;
        justify-content: flex-start;
        .bottom_div_1_left {
          margin-left: 10px;
          position: relative;
          .p1 {
            width: 20px;
            height: 1px;
          }
          .p2 {
            height: 20px;
            width: 1px;
          }
          .p4 {
            position: absolute;
            top: 56px;
            left: 0;
            background-color: #ee8835;
            @media (max-width: 576px) {
              top: 15px;
            }
          }
          .p3 {
            font-size: 14px;
            color: #524c4b;
            margin: 60px 10px 0;
            @media (max-width: 576px) {
              margin: 20px 10px 0;
            }
          }
        }
        .bottom_div_1_right {
          p {
            width: 2px;
            height: 30px;
            margin: 6px auto;
            background-color: #ee8835;
            @media (max-width: 576px) {
              display: none;
            }
          }
          img {
            width: 78px;
            height: 78px;
            background-size: 100% 100%;
          }
          .img_5 {
            @media (max-width: 576px) {
              margin-left: 24px;
            }
          }
        }
      }
      .bottom_div_3 {
        left: 420px;
      }
      .bottom_div_4 {
        left: 1034px;
        min-width: 200px;
      }
    }
  }
}

.gating {
  margin: 80px auto 30px;
  width: 1200px;
  @media (max-width: 576px) {
    margin-top: 30px;
    width: 100%;
  }
  .gating_content {
    margin-top: 30px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .gating_content_left {
      width: 450px;
      text-align: center;
      @media (max-width: 576px) {
        width: 100%;
      }
      .gating_content_div1 {
        p {
          margin: 0;
          font-size: 24px;
          color: #333;
          line-height: 32px;
        }
      }
      .gating_content_div2 {
        img {
          @media (max-width: 576px) {
            width: 100%;
          }
        }
      }
      .gating_content_div3 {
        display: flex;
        justify-content: space-between;
        @media (max-width: 576px) {
          width: 100%;
        }
        div {
          img {
            width: 110px;
            height: 110px;
            background-size: 100% 100%;
            @media (max-width: 576px) {
              width: 100px;
              height: 100px;
            }
          }
          p {
            text-align: center;
            font-size: 14px;
            color: #333;
            margin-top: 10px;
          }
        }
        .div_1 {
          margin-left: -24px;
          @media (max-width: 576px) {
            margin-left: 0;
          }
        }
      }
    }
    .gating_content_right {
      width: 700px;
      margin-left: 50px;
      text-align: center;
      @media (max-width: 576px) {
        margin: 30px 0 0;
        width: 100%;
      }
      .gating_content_div4 {
        p {
          margin: 0;
          font-size: 24px;
          color: #333;
          line-height: 32px;
        }
      }
      .gating_content_div5 {
        img {
          // width: 400px;
          @media (max-width: 576px) {
            width: 100%;
          }
        }
      }
      .gating_content_div6 {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        @media (max-width: 576px) {
          justify-content: space-around;
        }
        div {
          img {
            width: 110px;
            height: 110px;
            background-size: 100% 100%;
          }
          p {
            text-align: center;
            font-size: 14px;
            color: #333;
            margin-top: 10px;
          }
        }
        .div_2 {
          margin-left: 14px;
          @media (max-width: 576px) {
            margin-left: 0;
          }
        }
      }
    }
  }
}

.ladder {
  margin: 80px 0;
  padding: 60px 0 80px;
  box-shadow: 0 -10px 10px -3px #efefef;
  @media (max-width: 576px) {
    width: 98%;
    margin: 80px auto;
  }
  .ladder_img {
    width: 1200px;
    height: 400px;
    margin: 50px auto;
    @media (max-width: 576px) {
      width: 100%;
      height: 250px;
    }
    img {
      width: 100%;
      height: 400px;
      background-size: 100% 100%;
      @media (max-width: 576px) {
        height: 250px;
      }
    }
  }

  .ladder_content {
    margin: 40px auto 0;
    width: 1200px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    @media (max-width: 576px) {
      width: 98%;
    }
    .ladder_content_div {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      width: 44%;
      @media (max-width: 576px) {
        width: 100%;
      }
      .ladder_content_div_content {
        display: flex;
        justify-content: flex-start;
        .left {
          .img_1 {
            width: 110px;
            height: 100px;
            background-size: 100% 100%;
          }
          .img_2 {
            width: 110px;
            height: 100px;
            background-size: 100% 100%;
          }
          .img_3 {
            width: 140px;
            height: 100px;
            background-size: 100% 100%;
          }
          .img_4 {
            width: 140px;
            height: 100px;
            background-size: 100% 100%;
          }
          p {
            font-size: 22px;
            color: #ee8835;
            text-align: center;
          }
        }
        .right {
          padding: 16px 0 0 30px;
          @media (max-width: 576px) {
            padding-top: 0;
          }
          p {
            font-size: 16px;
            color: #403d3d;
            margin: 0;
            line-height: 22px;
            span {
              display: inline-block;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background-color: #000;
              margin-right: 4px;
            }
          }
        }
      }
    }
    .right_div {
      margin-left: 8%;
      @media (max-width: 576px) {
        margin-left: 0;
      }
      .ladder_content_div_content_4 {
        @media (max-width: 576px) {
          margin-top: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/community/community.vue